// @flow
import * as React from 'react';
import {useHistory, useParams} from 'react-router-dom';
import styled from 'styled-components';
import {BackgroundImage} from 'components/Image';
import {LayoutInline, LayoutWrapper} from 'components/Layout';
import {Paragraph, useLocalized} from 'components/Localized';
import Logo from 'components/Logo'
import {useSessionDispatch} from 'components/Session';
//import Settings from 'config/Settings'
import {preloadSceneColorSelectAssets, preloadSceneColorSelectAssets2} from 'utils/vrUtils';
import Disclaimer from 'components/Disclaimer'
import * as AudioUtils from 'utils/audioUtils';
import SoundToggleButton from 'components/SoundToggleButton';
import ButtonNextPage from 'components/ButtonNextPage';

type Props = {
  prevPath: string,
  nextPath: string,
}

export default function SurveyResult(props: Props): React.Element<any> {
  const history = useHistory();
  const sessionDispatch = useSessionDispatch();
  const localized = useLocalized();
  const { cv } = useParams();
  const [selected, setSelected] = React.useState(cv);

  // const handleTryAgain = React.useCallback(() => {
  //   const prevPath = cv === 'cv-e-gt' ? `${props.prevPath}/cv-gt-line` : `${props.prevPath}/cv-e-gt`;
  //   history.push(prevPath);
  //   sessionDispatch({type: 'SELECT_CAR', data: cv === 'cv-e-gt' ? 1 : 0});
  //   window.tagManager.driveTypeSurveyResultTryAgainLinkClick();
  // }, [cv, history, props.prevPath, sessionDispatch])

  const handleSelectA = React.useCallback(() => {
    setSelected('cv-e-gt');
  }, [])

  const handleSelectB = React.useCallback(() => {
    setSelected('cv-gt-line');
  }, [])

  const handleNext = React.useCallback(() => {
    window.tagManager.driveTypeSurveyResultNextLinkClick();
    if (cv !== selected) {
      const prevPath = cv === 'cv-e-gt' ? `${props.prevPath}/cv-gt-line` : `${props.prevPath}/cv-e-gt`;
      history.push(prevPath);
      sessionDispatch({type: 'SELECT_CAR', data: cv === 'cv-e-gt' ? 1 : 0});
    }
    history.push(props.nextPath.replace(":cv", selected));
  }, [cv, selected, history, props.prevPath, props.nextPath, sessionDispatch]);

  React.useEffect(()=>{
    if (cv === "cv-e-gt") {
      window.tagManager.surveyResult_EGT_Page();
    } else {
      window.tagManager.surveyResult_GTL_Page();
    }
    
  },[cv]);

  React.useEffect(()=>{
    AudioUtils.playBGM_UI();
    return ()=>{
    };
  }, []);

  React.useEffect(() => {
    if (cv === "cv-gt-line") {
      preloadSceneColorSelectAssets2();
    } else {
      //cv == cv-e-gt
      preloadSceneColorSelectAssets();
    }

    
  }, [cv])

  return (
    <main>
      <Wrapper>
        <LayoutInline>
          <Paragraph
            textKey={selected === 'cv-e-gt' ? "tutorial_p03_survey_210308_002" : "tutorial_p03_survey_210308_003"}
          />
        </LayoutInline>
        <LayoutInline>
          <button onClick={handleSelectA}>
            <CarImage isSelected={selected === 'cv-e-gt'}>
              <CarImageUnselected source="./survey/img-result-a-small.png" isSelected={selected === 'cv-e-gt'}/>
              <CarImageSelected source="./survey/img-result-a-big.png" isSelected={selected === 'cv-e-gt'}/>
              <Paragraph
              textKey={selected === 'cv-e-gt' ? "tutorial_p03_result_210426_001" : "tutorial_p03_result_210426_003"}
              />
            </CarImage>
          </button>
          <button onClick={handleSelectB}>
            <CarImage isSelected={selected !== 'cv-e-gt'}>
              <CarImageUnselected source="./survey/img-result-b-small.png" isSelected={selected !== 'cv-e-gt'}/>
              <CarImageSelected source="./survey/img-result-b-big.png" isSelected={selected !== 'cv-e-gt'}/>
              <Paragraph
              textKey={selected !== 'cv-e-gt' ? "tutorial_p03_result_210426_002" : "tutorial_p03_result_210426_004"}
              />
            </CarImage>
          </button>
        </LayoutInline>
        <div />
      </Wrapper>
      <Logo />
      <SoundToggleButton />
      <ButtonNextPage buttons={[{onNext: handleNext, title: localized.tutorial_p03_survey_008}]} />
      <Disclaimer textKey="disclaimer_default" />
    </main>
  );
}

const Wrapper = styled(LayoutWrapper)`
  display: flex;
  flex-direction: column;
  text-align: center;
  position: absolute;

  background-color: #05141f;
  color: #ffffff;

  padding-top: ${props => props.theme.layout.mobile ? 41 * (Math.max(props.theme.layout.scale ?? 1, 1)) : 97}px;
  padding-bottom: ${props => props.theme.layout.mobile ? 41 * (Math.max(props.theme.layout.scale ?? 1, 1)) : 97}px;

  >:nth-child(1) {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    transform-origin: center top;
  }

  >:nth-child(2) {
    min-height: ${props => props.theme.layout.mobile ? 168 : 336}px;
    display: flex;
    align-items: center;
    justify-content: center;
    transform-origin: center center;

    >:nth-child(2) {
      margin-left: ${props => props.theme.layout.mobile ? -25 : -50}px;
    }
  }

  >:nth-child(3) {
    flex: 1;
  }
`;

const CarImage = styled.div`
  position: relative;
  width: ${props => props.theme.layout.mobile ? (props.isSelected ? 375 : 248) : (props.isSelected ? 750 : 493)}px;
  height: ${props => props.theme.layout.mobile ? (props.isSelected ? 168 : 108) : (props.isSelected ? 336 : 215)}px;
  transition: all 0.5s;
  background-size: contain;
  background-repeat: no-repeat;

  display: ${props => props.isSelected ? 'inherit' : 'flex'};
  align-items: center;
  justify-content: center;

  > div {
    
  }

  > p {
    position: relative;
    text-align: ${props => props.isSelected ? 'left' : 'center'};
    min-width: ${props => props.theme.layout.mobile ? 133 : 222}px;
    padding-left: ${props => props.theme.layout.mobile ? (props.isSelected ? 68 : 0) : (props.isSelected ? 135 : 0)}px;
    padding-top: ${props => props.theme.layout.mobile ? (props.isSelected ? 15 : 0) : (props.isSelected ? 30 : 0)}px;
    padding-right: ${props => props.theme.layout.mobile ? (props.isSelected ? 0 : 8) : (props.isSelected ? 0 : 15)}px;
  }
`;

const CarImageSelected = styled(BackgroundImage)`
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0px;
  top: 0px;
  visibility: ${props => props.isSelected ? 'visible' : 'hidden'};
`;

const CarImageUnselected = styled(BackgroundImage)`
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0px;
  top: 0px;
  visibility: ${props => !props.isSelected ? 'visible' : 'hidden'};
`;
